import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class ProfileImageDao {
  static async fetchImage(env: Environment, size: number, personId: number) {
    const url = hostsConfig[env].wolverineServiceUrl;
    const { data } = await axios.get<string>(
      `${url}/images/image/${personId}/${size}/${size}`
    );
    return data;
  }
}
